<template>
    <h4><code-outlined/> Code {{data.action + 1}}</h4>
    <div v-for="(cK, cKIndex) in codeKeys" :key="cKIndex" >
        <div>
            <span v-if="cK === 'code'">
                <code-data :data="'```' + data[cK] +'```'"></code-data>
            </span>
            <div v-else>
                <more-less :data="data[cK]"></more-less>
            </div>

        </div>
    </div>
</template>

<script>
    import {
        CodeOutlined,
    } from '@ant-design/icons-vue';
    import CodeData from "../components/CodeData";
    import MoreLess from "../components/MoreLess";
    export default {
        name: "CodeInfo",
        props: ['data'],
        components: {
            'code-outlined': CodeOutlined,
            'code-data': CodeData,
            'more-less': MoreLess,
        },
        data (){
            let maxLength = 100;
            return {
                maxLength,
                codeKeys: ['task', 'code'],
            }
        },
    }
</script>

<style>
    .more-link, .less-link {
        cursor: pointer;
        color: blue;
    }
</style>
